/**
 * useFlowchartState - Local state management for flowchart
 */

import { useState, useCallback } from 'react';

export function useFlowchartState() {
  const [nodeDimensions, setNodeDimensions] = useState({});
  const [snapToGrid, setSnapToGrid] = useState(false);

  const handleDimensionsChange = useCallback((taskId, dimensions) => {
    setNodeDimensions(prev => {
      const prevDims = prev[taskId];
      if (prevDims) {
        const widthDiff = Math.abs(prevDims.width - dimensions.width);
        const heightDiff = Math.abs(prevDims.height - dimensions.height);
        if (widthDiff < 5 && heightDiff < 5) return prev;
      }
      return { ...prev, [taskId]: dimensions };
    });
  }, []);

  return {
    nodeDimensions,
    setNodeDimensions,
    snapToGrid,
    setSnapToGrid,
    handleDimensionsChange,
  };
}

export default useFlowchartState;
